import React, { FC, HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';

import { BaseFlex } from '../layouts/Flex/Flex';
import { getInputStateType } from './Input/getInputStateType';

const StyledInputFieldImage = styled('img')(
  css({
    width: 'input.image.width',
    height: 'input.image.height',
  })
);

type InputFieldImageContainerProps = {
  disabled?: boolean;
  invalid?: boolean;
  focus?: boolean;
  stateType?: string;
};

export const InputFieldImageContainer = styled(
  BaseFlex
)<InputFieldImageContainerProps>(
  css({
    px: '2x_small',
    alignItems: 'center',
  }),
  (props) =>
    css({
      borderColor: `input.${getInputStateType(props)}.color`,
      backgroundColor: `input.${getInputStateType(props)}.bg`,
    })
);

export const InputFieldImage: FC<HTMLAttributes<HTMLImageElement>> = (
  props
) => (
  <InputFieldImageContainer {...props}>
    <StyledInputFieldImage {...props} />
  </InputFieldImageContainer>
);
